import { prop,propObject,propArray,required,maxLength,range  } from "@rxweb/reactive-form-validators"
import { gridColumn } from "@rxweb/grid"


export class vMonthlyRetainedServiceRecordBase {

//#region monthlyRetainedServiceId Prop
        @gridColumn({visible: true, columnIndex:0, allowSorting: true, headerKey: 'monthlyRetainedServiceId', keyColumn: true})
        monthlyRetainedServiceId : number;
//#endregion monthlyRetainedServiceId Prop


//#region monthlyRetainedOptionId Prop
        @gridColumn({visible: true, columnIndex:1, allowSorting: true, headerKey: 'monthlyRetainedOptionId', keyColumn: false})
        monthlyRetainedOptionId : number;
//#endregion monthlyRetainedOptionId Prop


//#region monthlyRetainedServiceName Prop
        @gridColumn({visible: true, columnIndex:2, allowSorting: true, headerKey: 'monthlyRetainedServiceName', keyColumn: false})
        monthlyRetainedServiceName : string;
//#endregion monthlyRetainedServiceName Prop


//#region monthlyRetainedServiceTypeId Prop
        @gridColumn({visible: true, columnIndex:3, allowSorting: true, headerKey: 'monthlyRetainedServiceTypeId', keyColumn: false})
        monthlyRetainedServiceTypeId : number;
//#endregion monthlyRetainedServiceTypeId Prop


//#region createdBy Prop
        @gridColumn({visible: true, columnIndex:5, allowSorting: true, headerKey: 'createdBy', keyColumn: false})
        createdBy : number;
//#endregion createdBy Prop


//#region createdOn Prop
        @gridColumn({visible: true, columnIndex:6, allowSorting: true, headerKey: 'createdOn', keyColumn: false})
        createdOn : any;
//#endregion createdOn Prop


//#region isRequired Prop
        @gridColumn({visible: true, columnIndex:6, allowSorting: true, headerKey: 'isRequired', keyColumn: false})
        isRequired : boolean;
//#endregion isRequired Prop


//#region statusId Prop
        @gridColumn({visible: true, columnIndex:4, allowSorting: true, headerKey: 'statusId', keyColumn: false})
        statusId : number;
//#endregion statusId Prop

}